import getGeoLocation from './api/geotarget';
import {
  LOTUS,
  LOLA,
  NCEP,
  LOTUS_ON,
  LOTUS_OFF,
} from './constants';

export const getAllowedModels = (treatment) => {
  if (treatment === LOTUS_ON) {
    return [LOTUS, LOLA, NCEP];
  }

  if (treatment === LOTUS_OFF) {
    return [LOLA, NCEP];
  }

  return [LOTUS];
};

const locationDetails = async (clientIp, cfIPCountry) => {
  const details = {
    cfIPCountry,
    ip: clientIp,
    countryCode: 'US',
    location: { latitude: 32.715738, longitude: -117.161084 },
  };

  try {
    const { location, country: { iso_code } } = await getGeoLocation(clientIp);
    details.countryCode = iso_code; // eslint-disable-line camelcase
    details.location = location;
  } catch (err) {
    // console.error({
    //   error: err.stack,
    //   resp: JSON.stringify(err),
    // });
    console.log('ERROR: Error fetching user Location. Defaulting to US location.');
  }

//   log.info({ details });

  return details;
};

export { locationDetails };



// WEBPACK FOOTER //
// ./src/common/helpers.js